import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { UserTriggerName } from '@frontend/user/types';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import useUserTriggerSelect from './user-trigger-select.controller';

const ID = 'user-trigger-select';

export interface UserTriggerSelectProps extends Omit<SelectInputV2Props<UserTriggerName>, 'options'> {
    subset?: string[];
    dispatch?: ThunkDispatch<any, any, Action>;
}

export const UserTriggerSelect = (props: UserTriggerSelectProps) => {
    const viewProps = useUserTriggerSelect(props);

    return (
        <SelectInputV2<UserTriggerName>
            {...props}
            id={ID + props.id}
            label={props.label || 'User trigger'}
            options={viewProps.options}
        />
    );
};

export default UserTriggerSelect;
